import styled from "styled-components";
import { Link } from "react-router-dom";

export const PricingPage = styled.div`
  background: radial-gradient(
    circle farthest-corner at 18.5% 28.5%,
    #111 0,
    #000 91%
  );
  color: #ccc;
  text-align: center;
  height: 960px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: Roboto, sans-serif;

  @media screen and (max-width: 768px) {
    height: auto;
  }

  @media screen and (max-width: 480px) {
    height: auto;
  }
`;

export const H1 = styled.h1`
  color: #f7f8fa;
  text-align: center;
  padding: 2rem 0.5rem 2rem 0.5rem;
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const PricingContainer = styled.div`
  padding: 54px 0 48px 0;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PricingHeader = styled.h1``;

export const PricingCard = styled.div`
  background-image: linear-gradient(
    -25deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 600px;
  max-width: 300px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  margin-bottom: 24px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
  @media screen and (max-width: 768px) {
    max-width: 200px;
    max-height: 500px;
  }

  @media screen and (max-width: 480px) {
  }
`;

export const CardHeadingWrapper = styled.div`
  height: 48px;
  width: 160px;
  border-radius: 0 0 20px 20px;
`;

export const CardHeading = styled.h1`
  text-align: center;
  font-size: 28px;
  color: #fff;
  border-bottom: 1px solid #ccc;
`;

export const CardInfo = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const CardList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const CardListItem = styled.li`
  list-style: none;
  padding: 10px;
  text-align: center;
  color: lightgray;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px;
  border-radius: 10px;
`;

export const CardButton = styled(Link)`
  color: white;
  padding: 8px 20px;
  border-radius: 30px;
  border: 1px solid #adadad;
  text-decoration: none;

  :hover {
    background: #fff;
    color: #000;
  }
`;
